import { IoEyeOutline } from "react-icons/io5";
import React from "react";
import { usePosterReducers } from "../../../../redux/getdata/usePostReducer";
import ListComp from "../../components/ListComp";
import { dateFormat } from "../../../utils/common";
import { useNavigate } from "react-router-dom";
import { user_lists } from "../../../api/websocket/payload";
import Notfound from "../../components/Notfound";


interface IList {
  toggleWarn: Function;
}

const List: React.FunctionComponent<IList> = (props) => {
  const { user_list } = usePosterReducers();
  const navigate=useNavigate()

  const header = ["username","email","phone","display name","user type","Created At","Status",'Actions' ];
  return (
    <ListComp payLoad={user_lists} pages={user_list?.pagination} header={header}>
      {user_list?.data?.length >0 ?
        user_list?.data?.map((item, index) => (
          <tr key={index} className="border-b text-sm rounded-md  ">
            <td className="py-3">{item.username}</td>
            <td className="py-3">{item.email}</td>
            <td className="py-3">{item.phone}</td>
            <td className="py-3">{item.display_name}</td>
            <td className="py-3">{item.user_type}</td>

            <td>{dateFormat(item.created_at)}</td>
            <td className="px-4  text-sm py-2">
                  <label className="inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={item.is_active}
                      onChange={()=>{}}
                      onClick={(e) => props.toggleWarn(e,item,'edit')}
                     
                    />
                    <div className="relative w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-500 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[1px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                  </label>
                </td>
            <td>
            <button
                  onClick={() =>
                    navigate('/user-management/'+item.id)
                  }
                  className="p-2   text-black rounded-md"
                >
                  <IoEyeOutline />
                </button>
            </td>
          </tr>
        )):
        <Notfound msg="User Not Found!"/>

        }
    </ListComp>
  );
};

export default List;
